import type { AnalyticsClient, AnalyticsConfig } from '../shared/types.js';
import { ClientBase } from '../shared/client-base.js';

/**
 * Browser-flavoured client factory. Identical to server for now — both use the
 * in-memory buffer. In Phase 2 this will lazy-import `posthog-js` when a
 * `posthogKey` is supplied.
 */
export function createClientAnalytics(config: AnalyticsConfig = {}): AnalyticsClient {
  return new ClientBase(config);
}
